import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getCustomerSourceTypes = createAsyncThunk('getCustomerSourceTypes', async () => {
  const response = await apiService.getCustomerSourceTypes();

  return { customerSourceTypes: response.data };
});

const customerSourceTypesActions = { getCustomerSourceTypes };

export default customerSourceTypesActions;
